import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";
import { InstallationStatus } from "@/model/data/status/InstallationStatus";
import { InstallationStatusEnum } from "@/model/data/status/InstallationStatusEnum";
import { ConnectivityStatusEnum } from "@/model/data/status/ConnectivityStatusEnum";

export class FetchInstallationsStatusResponse extends ApiGenericResponse {
    installationsList: InstallationStatus[];
    totalInstallationsCount: number;
    totalCountByStatus: TotalByStatus[] = [];
    filteredTotalCountByStatus: TotalByStatus[] = [];
    totalCountByConnectivityStatus: TotalByConnectivityStatus[] = [];
    filteredTotalCountByConnectivityStatus: TotalByConnectivityStatus[] = [];

    constructor(response: AxiosResponse) {
        super(response);
        this.installationsList = [];
        this.totalInstallationsCount = 0;
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.DevicesStatus && obj.DevicesStatus.length > 0) {
            obj.DevicesStatus.forEach((e) => {
                let inst = new InstallationStatus();
                inst.parse(e);
                this.installationsList.push(inst);
            });
        }
        if (obj.TotalDeviceStatusCount) this.totalInstallationsCount = obj.TotalDeviceStatusCount;

        if (obj.TotalCountByStatus) {
            Object.entries(obj.TotalCountByStatus).forEach((pair: any) => {
                if (Object.values(InstallationStatusEnum).includes(pair[0])) this.totalCountByStatus.push(new TotalByStatus(pair[0], pair[1]));
            });
        }

        if (obj.FilteredTotalCountByStatus) {
            Object.entries(obj.FilteredTotalCountByStatus).forEach((pair: any) => {
                if (Object.values(InstallationStatusEnum).includes(pair[0])) this.filteredTotalCountByStatus.push(new TotalByStatus(pair[0], pair[1]));
            });
        }

        if (obj.TotalCountByConnectivityStatus) {
            Object.entries(obj.TotalCountByConnectivityStatus).forEach((pair: any) => {
                if (Object.values(ConnectivityStatusEnum).includes(pair[0])) this.totalCountByConnectivityStatus.push(new TotalByConnectivityStatus(pair[0], pair[1]));
            });
        }

        if (obj.FilteredTotalCountByConnectivityStatus) {
            Object.entries(obj.FilteredTotalCountByConnectivityStatus).forEach((pair: any) => {
                if (Object.values(ConnectivityStatusEnum).includes(pair[0])) this.filteredTotalCountByConnectivityStatus.push(new TotalByConnectivityStatus(pair[0], pair[1]));
            });
        }
    }
}

export class TotalByStatus {
    installationStatus: InstallationStatusEnum;
    total: number;

    constructor(installationStatus: string, total: number) {
        this.installationStatus = InstallationStatusEnum[installationStatus];
        this.total = total;
    }
}

export class TotalByConnectivityStatus {
    installationStatus: ConnectivityStatusEnum;
    total: number;

    constructor(installationStatus: string, total: number) {
        this.installationStatus = ConnectivityStatusEnum[installationStatus];
        this.total = total;
    }
}
